import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { TextColorCheck } from '../utils/textColorCheck';

import './article.scss';

const COMPONENT_NAME = 'article';
const BEM = {
  BLOCK: COMPONENT_NAME,
};

/**
 * version    1.0
 * class      <type> (Article)
 */
export class Article {
  constructor() {
    const self = this;

    this._els = {
      article: $(`.${BEM.BLOCK}`),
    };

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      self._els.article.each(function () {
        const $instanceEl = $(this);
        TextColorCheck._checkBackground($instanceEl);
      });
    });
  }
}
